import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ProcurementService } from '../../_services/procurement.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { LookupService } from '../../_services/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { Request } from '../../_model/procurement/Request';
import { User } from '../../_model/user';

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class RejectDialogComponent implements OnInit {

  currentUser: User;
  rejectForm: FormGroup;
  rejectReasons: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RejectDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Request,
    private authService: AuthenticationService,
    private procurementService: ProcurementService,
    private lookupService: LookupService,
    private toastr: ToastrService
  ) {
    this.currentUser = this.authService.currentUserValue;
    this.rejectForm = this.fb.group({
      rejectReasonId: [null, Validators.required],
      rejectDescription: ['']
    });
  }

  ngOnInit() {
    //this.rejectReasons = this.lookupService.localRejectReasonLookupList();
    this.lookupService.listByLookupCode('RECORD_REJECT_REASON').subscribe({
      next: (response) => {
        if (response.success && response.responseData.items) {
          this.rejectReasons = response.responseData.items.sort((a, b) => 
            (a.displayOrder || 0) - (b.displayOrder || 0)
          );
          
          // "Diğer" seçeneğini bul (description'da "Diğer" veya "Other" içeren)
          const otherReason = this.rejectReasons.find(r => 
            r.description.toLowerCase().includes('diğer') || 
            r.description.toLowerCase().includes('other')
          );
          //this.otherReasonId = otherReason?.id || null;
          
          // İlk seçeneği varsayılan olarak seç
          if (this.rejectReasons.length > 0) {
            this.rejectForm.patchValue({ reasonType: this.rejectReasons[0].id });
          }
        }
        //this.loading = false;
      },
      error: (error) => {
        console.error('Error loading reject reasons:', error);
        alert('Red nedenleri yüklenirken hata oluştu!');
        //this.loading = false;
      }
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  rejectRequest() {
    if (this.rejectForm.invalid) {
      this.toastr.warning('Lütfen red nedeni seçiniz', 'Uyarı');
      return;
    }

    const request = {
      employeeId: this.currentUser.employeeId,
      operationRecordId: this.data.id,
      operationTableName: 'PURCHASE_ORDER', // Procurement için tablo adı
      rejectReasonId: this.rejectForm.value.rejectReasonId,
      rejectDescription: this.rejectForm.value.rejectDescription
    };

    this.procurementService.rejectRequest(request).subscribe({
      next: (result) => {
        this.toastr.success('Reddetme işlemi başarılı', '');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.toastr.error(error.error?.msg || 'Reddetme işlemi başarısız', 'Hata');
        this.dialogRef.close(false);
      }
    });
  }
}
